import styled from 'styled-components';
import { ReactSVG } from 'react-svg';
import { Stack } from '../../../../../Stack';

export const Wrapper = styled(Stack).attrs({
  justify: 'space-between',
  align: 'center',
})`
  width: 122px;
`;

export const NavigationIcon = styled(ReactSVG)``;

export const NavigationButton = styled.button`
  cursor: ${({ 'aria-disabled': ariaDisabled }) =>
    ariaDisabled ? 'default' : 'pointer'};
  color: ${({ theme }) => `${theme.configs.CTAButton.bgColor}`};
  opacity: ${({ 'aria-disabled': ariaDisabled }) => (ariaDisabled ? 0.5 : 1)};
  background: none;
  border: none;
  padding: 0;
  font-size: 0;
`;
